import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PermissionEnum, ResourceEnum } from '../../../../environments/shared-environment/permission';
import { MeService } from '../me/me.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(
    private readonly meService: MeService,
  ) { }

  public has(resource: ResourceEnum, permission: PermissionEnum): boolean {
    if (!permission) {
      return false;
    }

    const requiredRoles = environment.permission[resource]?.[permission];

    if (!requiredRoles?.length) {
      return false;
    }

    return this.hasAnyRole(requiredRoles);
  }

  public hasRole(role: string): boolean {
    return this.hasAnyRole([role]);
  }

  public hasAnyRole(requiredRoles: string[]): boolean {
    const user = this.meService.getMe();
    const userRoles = user?.roles;

    if (!userRoles?.length || !requiredRoles.length) {
      return false;
    }

    if (user?.context === 'app' && !requiredRoles.some(role => role.startsWith('app:'))) {
      return false;
    }

    const hasMasterRole = userRoles.some(role => role.startsWith('master:'));

    return requiredRoles.some(requiredRole =>
      userRoles.some(userRole =>
        userRole === requiredRole
        || (hasMasterRole && requiredRole.startsWith('admin:'))
        || (userRole.endsWith('*') && requiredRole.startsWith(userRole.slice(0, -1))),
      ),
    );
  }

}
